import { makeStyles } from '@material-ui/core/styles';

import React from 'react';
import globalStyles from '../assets/styles/global';

const useStyles = makeStyles(globalStyles);

/**
 * A React high-order-component to include global styles to a given component
 * Usage: withGlobalStyles(MyComponent)
 * Once done, the "props" will have a new key, "globalClasses", which contains the styles from global.js assets file
 */
function withGlobalStyles(WrappedComponent) {
    return (props) => {
        const classes = useStyles();
        return <WrappedComponent {...props} globalClasses={classes} />;
    };
}

// function withGlobalStyles<T>(WrappedComponent: React.ComponentType<T>) {
//     const WithGlobalStyles: React.FC<T> = (props) => {
//         const classes = useStyles();
//         return <WrappedComponent {...props} globalClasses={classes} />;
//     };
//     return WithGlobalStyles;
// }

export default withGlobalStyles;
